import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { ConfirmDialogTriggerDirective } from './dialog-trigger.directive';

@Component({
  selector: 'black-confirm-dialog',
  standalone: false,

  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.css',
})
export class ConfirmDialogComponent {
  @ContentChild(ConfirmDialogTriggerDirective) trigger:
    | ConfirmDialogTriggerDirective
    | undefined;

  @Input()
  title = 'Confirmation';

  @Input()
  bodyText = 'Are you sure you want to proceed?';

  @Input()
  triggerButtonText = 'open';

  @Input()
  confirmButtonText = 'Yes';

  @Input()
  showCancel = true;

  @Output()
  confirm = new EventEmitter();

  onConfirm() {
    this.confirm.emit();
  }

  @Input()
  confirmBtnLevel: 'success' | 'danger' | 'warning' = 'success';

  getConfirmButtonClass(level: string): string {
    switch (level) {
      case 'success':
        return 'daisy-btn daisy-btn-success text-success-content';
      case 'danger':
        return 'daisy-btn daisy-btn-error text-error-content';
      case 'warning':
        return 'daisy-btn daisy-btn-warning text-warning-content';
      default:
        return 'daisy-btn daisy-btn-default text-default-content';
    }
  }
}
